<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">View department</h4>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goBack" class="md-primary md-dense">
                            Back to List
                        </md-button>
                    </div>

                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>

export default {

    data: () => ({
        role: {
            name: null,
            type: 'station',
        },
    }),

    created () {
        this.get();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('departments/get', id);
                this.role = this.$store.getters['departments/station'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            if (
                this.$isDemo == 1 &&
                    ['1'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default departments.'
                );
                return;
            }
            try {
                await this.$store.dispatch('departments/update', this.station);
                await this.$store.dispatch(
                    'alerts/success',
                    'department updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        goBack () {
            this.$router.push({ name: 'Departments List' });
        },
    },
};

</script>
